<button (click)="logout()" mat-raised-button color="primary" style="margin-left: 85%; margin-top: 10px">
  Log Out</button>
<div style="width: 100%; text-align: center;">
  <div [style.margin-left.%]="(layoutManager.mobileMode) ? 0 : 10"
       [style.margin-right.%]="(layoutManager.mobileMode) ? 0 : 10"
       style="margin-top: 100px; text-align: left; max-width: 1200px">

    <mat-progress-bar *ngIf="updating" mode="indeterminate"></mat-progress-bar><br>
    <mat-card>
      <h2 mat-line>{{'partner-manager.card-1.title'|translate}}</h2>
      <div style="text-align: right;">
        <button (click)="openDialog()" [disabled]="updating" mat-raised-button color="primary" style="display: inline;margin-right: 20px">
          {{'partner-manager.card-1.action-1'|translate}}</button>
        <button (click)="saveChanges()" [disabled]="!changes" mat-raised-button color="primary" style="display: inline;">
          {{'partner-manager.card-1.action-2'|translate}}</button>
      </div>
      <mat-accordion>
        <mat-expansion-panel style="margin-top: 20px;" *ngFor="let soft of softwares.softwares; let i = index">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{soft.software_name.toUpperCase()}}
              <mat-divider style="margin-left: 20px; margin-right: 20px" [vertical]="true"></mat-divider>
              {{soft.versions | lastVersion}}
            </mat-panel-title>
            <mat-panel-description>
              {{soft.approved ? ('partner-manager.card-1.software-state-approved'|translate) :
              ('partner-manager.card-1.software-state-not-approved'|translate)}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="width: 100%">
            <br>
            <p mat-line style="font-size: 17px"><b>{{'partner-manager.card-1.software-details'|translate}}</b></p>
            <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider>
            <br>
            <!-- Version component -->
            <mat-form-field [style.width.%]="(layoutManager.mobileMode) ? 80 : 40" [style.margin-right.px]="30">
              <mat-chip-list #chipList aria-label="Versions selection">
                <mat-chip *ngFor="let version of getVersionsArray(soft.versions)"
                          [removable]="true" (removed)="removeVersion(soft, version)">
                  {{version}}
                  <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                </mat-chip>
                <input placeholder="{{'partner-manager.card-1.software-versions-placeholder'|translate}}"
                       [matChipInputFor]="chipList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="true"
                       (matChipInputTokenEnd)="addVersion(soft, $event)">
              </mat-chip-list>
            </mat-form-field>
            <!-- Price component -->
            <mat-form-field style="width: 100px">
              <input disabled="true" matInput #price placeholder="{{'partner-manager.card-1.software-price-placeholder'|translate}}"
                     [value]="soft.price"
                     (input)="changes=true;priceChanges(price,soft)">
            </mat-form-field>
            &euro;/month
            <!-- Description -->
            <mat-form-field [style.width.%]="(layoutManager.mobileMode) ? 80 : 40" [style.margin-right.px]="30">
              <textarea matInput #description placeholder="{{'partner-manager.card-1.software-description-placeholder'|translate}}"
                        [value]="basetos(soft.description)"
                        (input)="changes=true;descrChanges(description,soft)"></textarea>
            </mat-form-field>
            <!-- Short Description -->
            <mat-form-field  style="width: 200px">
              <input matInput #short_description
                     placeholder="{{'partner-manager.card-1.software-short-description-placeholder'|translate}}"
                     [value]="basetos(soft.short_description)"
                     (input)="changes=true;shDescrChanges(short_description,soft)">
            </mat-form-field>
            <!-- Properties -->
            <div style="background: whitesmoke; padding: 10px">
              <mat-form-field  style="width: 300px; margin-right: 20px">
                <mat-label>{{'partner-manager.card-1.software-short-property-type-label'|translate}}</mat-label>
                <mat-select #propType required [value]="propOption">
                  <mat-option *ngFor="let option of options" [value]="option">
                    {{option}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <br>
              <mat-form-field  style="width: 250px; margin-right: 50px">
                <input #propName matInput [value]=""
                       placeholder="{{'partner-manager.card-1.software-property-name-placeholder'|translate}}">
              </mat-form-field>
              <mat-form-field  style="width: 300px; margin-right: 20px">
                <input #propValue matInput [value]=""
                       placeholder="{{'partner-manager.card-1.software-property-value-placeholder'|translate}}">
              </mat-form-field>
              <button mat-stroked-button
                      matTooltip="{{'partner-manager.card-1.software-tooltip-value-1'|translate}}"
                      (click)="addOption(propName.value, propType.value, propValue.value, soft)">
                <mat-icon>add_circle</mat-icon></button>
              <mat-list>
                <mat-list-item *ngFor="let option of soft.properties">
                  {{option.name}} : {{option.value}} {{'partner-manager.card-1.software-tooltip-value-2'|translate}} - {{options[option.type]}}
                  <button mat-stroked-button style="margin-left: 30px" (click)="removeOption(option.name, soft)">
                    <mat-icon>delete</mat-icon></button>
                </mat-list-item>
                <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider>
              </mat-list>
            </div>
            <!-- Upload -->
            <div style="margin-top: 20px">
              <button mat-stroked-button (click)="openUploadDialog(soft.software_name)"><mat-icon>folder
              </mat-icon>&ensp;{{'partner-manager.card-1.software-button-upload'|translate}}</button>
              <p matLine style="display: inline">&ensp;{{getUploadedState(soft.software_name) ?
                ('software-upload-result-true'|translate) :
                ('software-upload-result-false'|translate)}}</p>
              <button [disabled]="!getUploadedState(soft.software_name)"
                      style="display: inline;margin-left: 20px; width: 30px"
                      (click)="download(soft.software_name)" mat-stroked-button>
                <mat-icon>get_app</mat-icon></button>
            </div>
            <!-- Informazioni abbonamenti -->
            <br>
            <p mat-line style="font-size: 17px"><b>{{'partner-manager.card-1.software-subs-title'|translate}}</b></p>
            <mat-divider [inset]="true" style="width: 100%;margin: auto;"></mat-divider>
            <p mat-line>{{'partner-manager.card-1.software-subs-active-label'|translate}}&nbsp;&nbsp;&nbsp;26</p>
            <p mat-line>{{'partner-manager.card-1.software-subs-total-label'|translate}}&nbsp;&nbsp;&nbsp;{{26*soft.price}}&ensp;&euro;</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card>
  </div>
  <div [style.margin-left.%]="(layoutManager.mobileMode) ? 0 : 10"
       [style.margin-right.%]="(layoutManager.mobileMode) ? 0 : 10"
       style="margin-top: 100px; text-align: left; max-width: 1200px">
    <mat-card>
      <h2 mat-line>{{'partner-manager.card-2.title'|translate}}</h2>
      <p mat-line style="font-size: 12px">{{'partner-manager.card-2.description'|translate}}</p>
      <button  mat-stroked-button
              matTooltip="{{'partner-manager.card-2.tooltip-1'|translate}}">
        https://assetstore.assetx.it/sign_in/{{stobase(sessions.getNameUser())}}
        <mat-icon style="margin-left: 10px">file_copy</mat-icon>
      </button>
      <mat-accordion>
        <mat-expansion-panel style="margin-top: 20px;" *ngFor="let aff of affiliates">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: 15px; margin-right: 10px">assignment_ind</mat-icon>
              <h4 matLine> {{basetos(aff.email)}} </h4>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- Lista dei sfotware dell'utente -->
          <h3>{{'partner-manager.card-2.softwares-title'|translate}}</h3>
          <div style="width: 100%">
            <ng-container *ngFor="let soft of aff.softwares">
              <mat-accordion>
                <mat-expansion-panel style="width: 60%;margin-top: 10px">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{soft.software.software_name.toUpperCase()}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                      (getSoftwareActivation(aff.software_access,soft.software.software_name)) ?
                        ('partner-manager.card-2.software-activation-true'|translate) :
                        ('partner-manager.card-2.software-activation-false'|translate)
                      }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div>
                    <h4 mat-line>{{'partner-manager.card-2.payments-title'|translate}}</h4>
                    <mat-list>
                      <mat-list-item role="listitem" *ngFor="let payment of soft.payment_recieved">
                        <mat-icon matListIcon>monetization_on</mat-icon>
                        <h3 matLine><b>{{payment.data | date: 'dd/MM/yyyy' }}</b></h3>
                        <p matLine>
                          <span>&euro; {{payment.importo.replace("EUR", "")}}</span> - {{
                          'partner-manager.card-2.payments-perc-label'|translate
                          }} -
                          <span>{{payment.storno}}</span>%
                          <span><mat-icon matListIcon>arroy_right_alt</mat-icon> {{
                            'partner-manager.card-2.payments-storno-label'|translate
                            }}: &euro; {{getStorno(payment)}}</span>
                        </p>
                      </mat-list-item>
                    </mat-list>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-container>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <br>
      <h2 mat-line>{{'partner-manager.card-2.payments-total-title'|translate}}</h2>
      <div style="width: 100%">
        <table mat-table [dataSource]="totalPayments" class="mat-elevation-z8" style="width: 100%">
          <!-- user Column -->
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.user}} </td>
            <td mat-footer-cell *matFooterCellDef><b>{{'partner-manager.card-2.payments-total-label'|translate}}</b></td>
          </ng-container>
          <!-- Software Column -->
          <ng-container matColumnDef="software">
            <th mat-header-cell *matHeaderCellDef> Software </th>
            <td mat-cell *matCellDef="let element"> {{element.software}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <!-- Data Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> {{'partner-manager.card-2.payments-data-label'|translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.date | date: 'dd/MM/yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <!-- Import Column -->
          <ng-container matColumnDef="import">
            <th mat-header-cell *matHeaderCellDef> {{'partner-manager.card-2.payments-import-label'|translate}} </th>
            <td mat-cell *matCellDef="let element"> &euro; {{element.import.replace("EUR", "")}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <!-- Software Column -->
          <ng-container matColumnDef="perc">
            <th mat-header-cell *matHeaderCellDef> {{'partner-manager.card-2.payments-perc-2-label'|translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.perc}}% </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <!-- Software Column -->
          <ng-container matColumnDef="storno">
            <th mat-header-cell *matHeaderCellDef> {{'partner-manager.card-2.payments-storno-label'|translate}} </th>
            <td mat-cell *matCellDef="let element"> &euro; {{element.storno}} </td>
            <td mat-footer-cell *matFooterCellDef> &euro; <b>{{importoTotale}}</b> </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
    </mat-card>
  </div>
  <div [style.margin-left.%]="(layoutManager.mobileMode) ? 0 : 10"
       [style.margin-right.%]="(layoutManager.mobileMode) ? 0 : 10"
       style="margin-top: 100px; text-align: left; max-width: 1200px">
    <mat-card>
      <h2 mat-line>{{'partner-manager.card-3.title'|translate}}</h2>
      <mat-list role="list">
        <ng-container *ngFor="let request of requests.requests; let i = index">
          <mat-list-item role="listitem" *ngIf="getSoftwareByName(request.software_name).approved">
            <div style="width: 80%; overflow-wrap: break-word;">
              {{request.software_name}}&emsp;-&emsp;{{basetos(request.email)}}
            </div>
            <button (click)="acceptRequest(request)"
                    style="margin-left: 50px" mat-icon-button aria-label="Example icon-button with a heart icon">
              <mat-icon>done</mat-icon>
            </button>
            <button (click)="deleteRequest(request)"
                    style="margin-left: 50px" mat-icon-button aria-label="Example icon-button with a heart icon">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </mat-list-item>
          <mat-divider *ngIf="i<requests.requests.length-1"></mat-divider>
        </ng-container>
      </mat-list>
    </mat-card>
  </div>
</div>
